import { TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useInfiniteTable } from 'hooks/useInfiniteTable';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { useCustomParamId } from 'hooks/useParamId';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { useGetContractProducts } from 'services/contract/products';
import { PRODUCT_TYPE } from 'services/contract/types';

const ContractProductsTab = () => {
  const contractId = useCustomParamId('contractId');

  const products = useGetContractProducts(contractId);

  const tableProps = useInfiniteTable(products);

  const navigateToNewWindow = useNewWindowNavigate();
  const navigate = useNavigate();

  return (
    <Table
      id='contract-products'
      //   size='compact'
      {...tableProps}
      data={{
        nodes: tableProps.data.nodes.map(p => ({
          ...p,
          id:
            p.productType.id === PRODUCT_TYPE.Digital
              ? `/music-product-digital/${p.id}/contracts`
              : p.productType.id === PRODUCT_TYPE.Physical
              ? `/music-product-physical/${p.id}/contracts`
              : p.productType.id === PRODUCT_TYPE.YouTube
              ? `/channel/${p.id}/contracts`
              : p.productType.id === PRODUCT_TYPE.Merch
              ? `/merch/${p.id}/contracts`
              : p.id,
        })),
      }}
      columns={[
        {
          label: t('input.label.type'),
          renderCell: ({ productType }) => (
            <TableItem>
              <TableItem.Text
                text={t(`enum.PRODUCT_TYPE.${PRODUCT_TYPE[productType.id]}`)}
              />
            </TableItem>
          ),
        },
        {
          label: t('input.label.title'),
          renderCell: ({ title }) => (
            <TableItem>
              <TableItem.Text text={title} />
            </TableItem>
          ),
        },
        {
          label: t('input.label.ean'),
          renderCell: ({ ean }) => (
            <TableItem>
              <TableItem.Text text={ean} />
            </TableItem>
          ),
        },
        // {
        //   label: '',
        //   renderCell: ({ productType, id }) => (
        //     <TableItem justifyPosition='end'>
        //       <Button
        //         isClear
        //         onlyIcon
        //         onClick={() =>
        //           navigateToNewWindow(
        //             productType.id === PRODUCT_TYPE.Digital
        //               ? `music-product-digital/${id}/contracts`
        //               : productType.id === PRODUCT_TYPE.Physical
        //               ? `music-product-physical/${id}/contracts`
        //               : ''
        //           )
        //         }>
        //         <Button.Icon
        //           icon={<PiNavigationArrow transform='scale(-1,1)' />}
        //         />
        //       </Button>
        //     </TableItem>
        //   ),
        // },
      ]}
    />
  );
};

export default ContractProductsTab;
